import axios from "../config";

export const getResources = () => {
  return axios.get("/resource");
};
